export const getSignedAmount = (amount, operation, irt) => {
  let output;
  const mAmount = irt
    ? parseInt(amount).toLocaleString()
    : amount.replace(/\.?0+$/, "");
  switch (operation) {
    case "BUY":
    case "DEPOSIT":
    case "GATEWAY":
    case "PAY":
    case "COMMISSION":
      output = <span>{mAmount}+</span>;
      break;
    case "SELL":
    case "WITHDRAW":
      output = <span>{mAmount}-</span>;
      break;
    default:
      output = <>{mAmount}</>;
      break;
  }
  return output;
};
